videojs.addLanguage('en', {
  "New feedback": "New feedback",
  "Report a problem": "Report a problem",
  "To resolve viewing issues, follow the link": "To resolve viewing issues, follow the ",
  "link": "link",
  "Select feedback theme": "Select theme",
  "Video problems": "Video problems",
  "Sound problems": "Sound problems",
  "Log in/sign up problems": "Log in/sign up problems",
  "Payment problems": "Payment problems",
  "Other problems": "Other problems",
  "Feedback email": "E-mail",
  "Feedback message": "Message",
  "Feedback send": "Send",
  "Feedback": "Report a problem",
  "Feedback send fail": "Message send has failed.",
  "Feedback send success": "Message sent successfully."
});
